import { FC } from "react";
import { Text } from "@chakra-ui/react";
import { StepContainer } from "~/OnboardingApp/components";
import { Trans } from "~/utils/i18next";

export const PersonalizedExperienceStep: FC = () => {
  return (
    <StepContainer>
      <Text textAlign="center">
        <Trans i18nKey="onboarding.welcomePage.step2.content" />
      </Text>
    </StepContainer>
  );
};
